/**
 * Estado de um site em três cores semânticas, sempre com o motivo em texto.
 */
import { StatusDot } from '@/components/atoms';
import type { PortalSiteResumo } from '@/types/portal';
import { estadoDoSite, type EstadoSemantico } from '@/utils/portal';

import styles from './Portal.module.css';

const ROTULO: Record<EstadoSemantico, string> = {
  ok: 'Saudável',
  warn: 'Atenção',
  crit: 'Crítico',
};

const CLASSE: Record<EstadoSemantico, string> = {
  ok: styles.estadoOk,
  warn: styles.estadoWarn,
  crit: styles.estadoCrit,
};

export function EstadoDoSite({ site, agora }: { site: PortalSiteResumo; agora: number }) {
  const e = estadoDoSite(site, agora);
  return (
    <span className={CLASSE[e.estado]} data-estado={e.estado}>
      <StatusDot state={e.estado} label={ROTULO[e.estado]} />
      <strong>{ROTULO[e.estado]}</strong>
      <span className={styles.mudo}>{e.motivo}</span>
    </span>
  );
}
